import styled from '@emotion/styled'
import isEmpty from 'lodash/isEmpty'
import {
  ApprovalDetails,
  DatasetStatus,
  PendingStatus,
  PendingStatusIndicator,
  SubmissionStatusIndicator,
} from '@components'
import { Submission } from '@global/types'

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

interface Props {
  submission: Submission
  datasetMeta: unknown
}

/**
 * Show the pending and approval status of a submission.
 * @param props React Props
 * @param {Submission} props.submission Submission object to include state and approval states.
 */
export const Status = ({ submission, datasetMeta }: Props) => {
  if (isEmpty(datasetMeta)) return null
  if (isEmpty(submission)) return null

  const submissionStatus = submission?.status || submission?.latest_submission_status
  const approvalStatus = submission?.approval_result?.approval_status || submissionStatus
  const isPendingStatus = Object.values(PendingStatus).includes(submissionStatus as PendingStatus)
  const showApprovalDetails =
    approvalStatus === PendingStatus.REJECTED || approvalStatus === DatasetStatus.APPROVED

  return (
    <StatusContainer data-testid="status-container">
      {isPendingStatus ? (
        <PendingStatusIndicator status={submissionStatus} data-testid="pending-status-indicator" />
      ) : (
        <SubmissionStatusIndicator
          status={submissionStatus as DatasetStatus}
          data-testid="submission-status-indicator"
        />
      )}
      {showApprovalDetails && submission?.approval_result && (
        <ApprovalDetails
          approvalResult={submission.approval_result}
          label={approvalStatus}
          data-testid="approval-details"
        />
      )}
    </StatusContainer>
  )
}
